import React, { useState } from 'react';
import { compressImage } from '../../utils/imageCompress';

export default function OrgLogoUpload({ orgId, currentLogo, onLogoUpdated }) {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(currentLogo || null);
  const [error, setError] = useState(null);

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setError(null);
    setUploading(true);

    try {
      // Compress and get base64
      const compressedData = await compressImage(file);
      setPreview(compressedData);

      // Upload to backend
      if (orgId) {
        const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5001'}/api/crm/organizations/${orgId}/upload-logo`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
          body: JSON.stringify({ imageData: compressedData }),
        });

        if (!response.ok) {
          throw new Error((await response.json()).error || 'Upload failed');
        }

        const result = await response.json();
        setPreview(result.logo_url);
        if (onLogoUpdated) onLogoUpdated(result.logo_url);
      }
    } catch (err) {
      setError(err.message);
      setPreview(currentLogo);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'center' }}>
      {preview ? (
        <img
          src={preview}
          alt="Organization logo"
          style={{
            maxWidth: 100,
            maxHeight: 100,
            objectFit: 'contain',
            background: '#1E2D45',
            padding: 8,
            borderRadius: 4,
            border: '1px solid #1E2D45',
          }}
        />
      ) : (
        <div style={{
          width: 100,
          height: 100,
          background: '#1E2D45',
          border: '1px dashed #1E2D45',
          borderRadius: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#6B7280',
          fontSize: 12,
        }}>
          No logo
        </div>
      )}

      <label style={{
        padding: '6px 12px',
        background: '#22D3EE44',
        color: '#22D3EE',
        border: '1px solid #22D3EE66',
        borderRadius: 4,
        cursor: uploading ? 'not-allowed' : 'pointer',
        fontSize: 11,
        fontWeight: 500,
        opacity: uploading ? 0.6 : 1,
        whiteSpace: 'nowrap',
      }}>
        {uploading ? 'Uploading...' : 'Upload Logo'}
        <input
          type="file"
          accept="image/*"
          onChange={handleFileSelect}
          disabled={uploading}
          style={{ display: 'none' }}
        />
      </label>

      {error && <div style={{ color: '#EF4444', fontSize: 11 }}>{error}</div>}
      <div style={{ color: '#6B7280', fontSize: 10 }}>PNG, JPG, SVG — max 200×200</div>
    </div>
  );
}
